import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
export function Footer() {
  const [openModal, setOpenModal] = useState<null | 'privacy' | 'terms'>(null);
  return <footer className="bg-navy-900 text-cream-100/60 py-12 px-6 border-t border-navy-800" data-id="element-16">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-17">
        <p className="text-sm leading-relaxed" data-id="element-18">
          Este producto no sustituye el consejo médico profesional, diagnóstico
          o tratamiento. Siempre busque el consejo de su médico u otro proveedor
          de salud calificado con cualquier pregunta que pueda tener respecto a
          una condición médica.
        </p>
        <div className="flex justify-center gap-6 text-sm" data-id="element-19">
          <button onClick={() => setOpenModal('terms')} className="hover:text-gold-400 transition-colors underline-offset-4 hover:underline" data-id="element-20">
            Términos y Condiciones
          </button>
          <button onClick={() => setOpenModal('privacy')} className="hover:text-gold-400 transition-colors underline-offset-4 hover:underline" data-id="element-21">
            Política de Privacidad
          </button>
        </div>
        <p className="text-sm" data-id="element-22">
          &copy; {new Date().getFullYear()} Memoria Blindada. Todos los derechos
          reservados.
        </p>
      </div>

      {/* Terms Modal */}
      <Modal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-23">
        <p className="text-sm text-charcoal-700" data-id="element-24">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        })}
        </p>

        <section data-id="element-25">
          <h3 className="font-serif text-xl font-bold text-navy-900 mb-2" data-id="element-26">
            1. Aceptación de los términos
          </h3>
          <p data-id="element-27">
            Al acceder, descargar o utilizar el material "Memoria Blindada",
            usted acepta cumplir con estos Términos y Condiciones. Si no está de
            acuerdo con alguna parte de los términos, no debe adquirir ni
            utilizar el producto.
          </p>
        </section>

        <section data-id="element-28">
          <h3 className="font-serif text-xl font-bold text-navy-900 mb-2" data-id="element-29">
            2. Naturaleza del producto
          </h3>
          <p data-id="element-30">
            Memoria Blindada es un producto digital educativo (PDF y materiales
            complementarios) diseñado para apoyar el entrenamiento cognitivo. No
            constituye un servicio médico, diagnóstico ni tratamiento. Los
            resultados pueden variar según la práctica y el compromiso de cada
            usuaria.
          </p>
        </section>

        <section data-id="element-31">
          <h3 className="font-serif text-xl font-bold text-navy-900 mb-2" data-id="element-32">
            3. Licencia de uso
          </h3>
          <p data-id="element-33">
            Tras la compra, le otorgamos una licencia personal, no exclusiva e
            intransferible para utilizar el material con fines personales. No
            está permitido revender, redistribuir, reproducir total o
            parcialmente el contenido con fines comerciales sin autorización por
            escrito.
          </p>
        </section>

        <section data-id="element-34">
          <h3 className="font-serif text-xl font-bold text-navy-900 mb-2" data-id="element-35">
            4. Pago y acceso
          </h3>
          <p data-id="element-36">
            El pago es único y otorga acceso de por vida al material adquirido.
            La descarga se entrega de forma inmediata tras la confirmación del
            pago a través de nuestra plataforma de procesamiento.
          </p>
        </section>

        <section data-id="element-37">
          <h3 className="font-serif text-xl font-bold text-navy-900 mb-2" data-id="element-38">
            5. Política de reembolso
          </h3>
          <p data-id="element-39">
            Por tratarse de un producto digital de descarga inmediata, las
            ventas son finales. Sin embargo, evaluamos solicitudes de reembolso
            caso por caso dentro de los primeros 7 días posteriores a la compra,
            siempre que se demuestre que el material no fue utilizado según lo
            prometido.
          </p>
        </section>

        <section data-id="element-40">
          <h3 className="font-serif text-xl font-bold text-navy-900 mb-2" data-id="element-41">
            6. Limitación de responsabilidad
          </h3>
          <p data-id="element-42">
            No garantizamos resultados específicos. La responsabilidad máxima de
            la empresa frente al usuario se limita al monto pagado por el
            producto. No nos hacemos responsables por decisiones tomadas con
            base en el contenido del material.
          </p>
        </section>

        <section data-id="element-43">
          <h3 className="font-serif text-xl font-bold text-navy-900 mb-2" data-id="element-44">
            7. Modificaciones
          </h3>
          <p data-id="element-45">
            Nos reservamos el derecho de actualizar estos términos en cualquier
            momento. Los cambios entrarán en vigor al publicarse en esta misma
            página.
          </p>
        </section>
      </Modal>

      {/* Privacy Modal */}
      <Modal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-46">
        <p className="text-sm text-charcoal-700" data-id="element-47">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        })}
        </p>

        <section data-id="element-48">
          <h3 className="font-serif text-xl font-bold text-navy-900 mb-2" data-id="element-49">
            1. Información que recopilamos
          </h3>
          <p data-id="element-50">
            Para procesar su compra recopilamos únicamente los datos
            estrictamente necesarios: nombre, correo electrónico e información
            de pago, esta última manejada de forma segura por la plataforma de
            procesamiento de pagos.
          </p>
        </section>

        <section data-id="element-51">
          <h3 className="font-serif text-xl font-bold text-navy-900 mb-2" data-id="element-52">
            2. Uso de la información
          </h3>
          <p data-id="element-53">
            Utilizamos sus datos únicamente para entregar el producto adquirido,
            enviar el acceso al material y comunicaciones esenciales sobre su
            compra. No compartimos ni vendemos sus datos personales a terceros
            con fines comerciales.
          </p>
        </section>

        <section data-id="element-54">
          <h3 className="font-serif text-xl font-bold text-navy-900 mb-2" data-id="element-55">
            3. Cookies
          </h3>
          <p data-id="element-56">
            Nuestro sitio puede utilizar cookies básicas para garantizar el
            correcto funcionamiento de la página y para fines analíticos
            agregados. Usted puede desactivar las cookies desde la configuración
            de su navegador.
          </p>
        </section>

        <section data-id="element-57">
          <h3 className="font-serif text-xl font-bold text-navy-900 mb-2" data-id="element-58">
            4. Seguridad de los datos
          </h3>
          <p data-id="element-59">
            Aplicamos medidas técnicas y organizativas razonables para proteger
            sus datos contra el acceso no autorizado, la alteración o la
            divulgación. Las transacciones se realizan a través de procesadores
            de pago certificados con cifrado de extremo a extremo.
          </p>
        </section>

        <section data-id="element-60">
          <h3 className="font-serif text-xl font-bold text-navy-900 mb-2" data-id="element-61">
            5. Conservación de los datos
          </h3>
          <p data-id="element-62">
            Conservamos su información el tiempo necesario para cumplir con
            obligaciones legales, fiscales y para garantizar el acceso continuo
            al material adquirido.
          </p>
        </section>

        <section data-id="element-63">
          <h3 className="font-serif text-xl font-bold text-navy-900 mb-2" data-id="element-64">
            6. Sus derechos
          </h3>
          <p data-id="element-65">
            Usted tiene derecho a solicitar acceso, rectificación o eliminación
            de sus datos personales, así como a oponerse a su tratamiento, en
            cumplimiento con las leyes de protección de datos aplicables.
          </p>
        </section>

        <section data-id="element-66">
          <h3 className="font-serif text-xl font-bold text-navy-900 mb-2" data-id="element-67">
            7. Cambios en esta política
          </h3>
          <p data-id="element-68">
            Podemos actualizar esta política para reflejar cambios en nuestras
            prácticas o por motivos legales. Cualquier modificación será
            publicada en esta página con la fecha de actualización
            correspondiente.
          </p>
        </section>
      </Modal>
    </footer>;
}